function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m26.001 13.998h-4.999v-2.998c0-.553-.447-1-1-1s-1 .447-1 1v2.998h-5.002c-.55 0-1 .45-1 1v3.001c0 .55.45.999 1 .999h5.002v2h-2.998c-.552 0-1.004.452-1.004 1.004v2.993c0 .552.452 1.003 1.004 1.003h2.998v3.002c0 .553.447 1 1 1s1-.447 1-1v-3.002h2.995c.552 0 1.003-.451 1.003-1.003v-2.993c0-.552-.451-1.004-1.003-1.004h-2.995v-2h4.999c.55 0 .999-.449.999-.999v-3.001c0-.55-.449-1-.999-1",
  fillRule: "evenodd",
  transform: "translate(-13 -10)"
});

var SvgAlignHCenter = function SvgAlignHCenter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 14 20",
    width: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlignHCenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/align-h-center.31b8437d.svg";
export { ForwardRef as ReactComponent };